// *************************** Import CSS *************************** //

import "./nav-header-footer.css";

//*** Cart Icon ***//

import "/src/assets/general-icons/white-shopping-cart.png";

//*** Social Icons ***//

import "/src/assets/social-icons/instagram-colorful.svg";

// **************** Function Spinner Show & Hide ******************** //

  function spinnerShow() {
    document.getElementById("function-spinner").style.display = "block";
  }

  function spinnerHide() {
    document.getElementById("function-spinner").style.display = "none";
  }

// ********************** Cart Item Count ************************* //

  let cartItemCount = sessionStorage.getItem("retroFoilsQuant");

  function updateCartQuantityDisplay() {

    const cartCountElement = document.getElementById('cart-item-count');
        
    if (cartCountElement) {
        
      cartCountElement.textContent = cartItemCount;
      //console.log("Cart Item Count: ", cartItemCount);
          
      if (cartItemCount == 0) {
        cartCountElement.style.display = 'none';
      } else {
        cartCountElement.style.display = 'block';
      }
    }
  }

  // Function to handle the update
function handleStorageChange(event) {

    if (event.detail && event.detail.key === 'retroFoilsQuant') {

        // Handle custom event from the same window
        //console.log('Listener script (same window): sessionStorage "retroFoilsQuant" updated to:', event.detail.newValue);

        const cartCountElement = document.getElementById('cart-item-count');

        const updatedValue = sessionStorage.getItem(event.detail.key);



      if (cartCountElement) {
        
      cartCountElement.textContent = updatedValue;
      //console.log("Cart Item Count: ", updatedValue);
          
      if (updatedValue == 0) {
        cartCountElement.style.display = 'none';
      } else {
        cartCountElement.style.display = 'block';
      }
    }



    } else if (event.key === 'retroFoilsQuant') {

        // Handle the standard 'storage' event from another tab/window
        //console.log('Listener script (different tab): sessionStorage "retroFoilsQuant" updated to:', event.newValue);
        
        const cartCountElement = document.getElementById('cart-item-count');

        const updatedValue = sessionStorage.getItem(event.detail.key);

      if (cartCountElement) {
        
      cartCountElement.textContent = updatedValue;
      //console.log("Cart Item Count: ", updatedValue);
          
      if (updatedValue == 0) {
        cartCountElement.style.display = 'none';
      } else {
        cartCountElement.style.display = 'block';
      }
    }

    }
}

// Listen for the custom event (same window communication)
window.addEventListener('sessionStorageUpdated', handleStorageChange);

// Listen for the standard storage event (cross-tab/iframe communication)
// Note: This only fires if the change happened in a different window/tab
window.addEventListener('storage', handleStorageChange);


// Ensure the DOM is fully loaded before running the script
document.addEventListener('DOMContentLoaded', (event) => {

    const cartLink = document.getElementById("cart-link");

    cartLink.addEventListener('click', (e) => {

      //console.log("Cart link clicked");

      if (cartItemCount == 0 || cartItemCount == null) {
        document.getElementById("cart-link").setAttribute("href", "order.html");
      } else {
        document.getElementById("cart-link").setAttribute("href", "checkout.html");
      }

    });
});

// *************************************************** Insert HTML - Navigation Menu **************************************************** //

class FirstNav extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `

    <section class="sticky-header"> 
      
      <nav class="navbar">
    
        <div class="website-logo">

          <a href="index.html">
            <h1 class="foiled-logo foiled-font">foiled.<span class="pretty-logo pretty-font">PRETTY</h1>
          </a>
      
        </div>
      
   
        <ul class="nav-links">

          <!-- HAMBURGER MENU -->
              
          <input type="checkbox" id="checkbox_toggle" />
            
          <label for="checkbox_toggle" class="hamburger">&#9776;</label>

          
          <!-- NAVIGATION MENUS -->
              
          <div class="menu">

            <li><a href="index.html">Home</a></li>
            
            <li><a href="order.html">Order</a></li>
                
            <li><a href="about.html">About</a></li>
                
            <li><a href="faqs.html">FAQs</a></li>
                
            <li><a href="contact.html">Contact</a></li>

            <li>

              <a href="checkout.html" id="cart-link">

              <div class="cart-icon-container">
                <img class="cart-icon" src="white-shopping-cart.png" width="30px" height="30px">
                <span id="cart-item-count" class="cart-quantity">0</span>
              </div>

              </a>

            </li>

            <li>
              <a class="insta-img" href="https://www.instagram.com/_getfoiled.pretty/" target="_blank">
                <img src="instagram-colorful.svg" width="30" height="30" class="insta-img" alt="Instagram icon" />
              </a>
            </li> 
        
          </div>
          
        </ul>
  
      </nav>
    
    </section>

    `
  }
}

// ************************************************ Insert HTML - Email Contact Form *********************************************************** //

class EmailSignupForm extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `

      <section class="email-form">

      <user-popup></user-popup>
    
        <div class="email-form-container">

            <!-- Title -->

              <div class="email-form-title">
        
                <p class="get-notified-text">Get Notified About Product &#38; Purchasing Updates</p>

              </div>

              <!-- Email Form -->

              <form id="emailForm" action="" name="submit-to-google-sheet">

                <div class="email-form-data">

                  <div class="email-form-first-name">
                    <input type="text" id="firstName" class="form-text-box" name="firstName" placeholder="First Name" aria-label="Enter first name" required />
                    </div>

                    <div class="email-form-last-name">
                      <input class="form-control" type="text" id="lastName" name="lastName" placeholder="Last Name" aria-label="Enter last name">
                    </div>

                    <div class="email-form-email">
                      <input class="form-control" type="email" id="email" name="email" placeholder="Email Address" aria-label="Enter email address">
                    </div>

                    <div class="email-form-signup">
                      <input id="submit-button" class="submit-button" type="submit" value="Submit" />
                    </div>

              </div>

            </form>

        </div>

      </section>

    `
  }
}

// ************************************************ Insert HTML - Footer *********************************************************** //

class Footer extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `

      <section class="footer"> 

        <div class="footer-fp">
          <p class=”footer-text”>&copy; 2025 <a href="admin.html">foiled.<span class="pretty-footer-text">PRETTY</span></a></p>
        </div>
    
      </section>

    `
  }
}

// *********************** Define 'extends HTMLElements' Above *********************** //

customElements.define('first-nav', FirstNav);
customElements.define('email-signup-form', EmailSignupForm);
customElements.define('footer-nav', Footer);

updateCartQuantityDisplay()